import lottieWeb from 'lottie-web'

export const lottieAnimations = () => {

  const containers = document.querySelectorAll('[data-lottie]')

  if (!containers.length) return 

  containers.forEach(container => {

    const name = container.dataset.lottie
    const animation = lottieWeb.loadAnimation({ 
      container: container,
      autoplay: true,
      renderer: 'svg',
      loop: true,
      path: '/lottie/' + name + '.json'
    })

    animation.setSubframe(false) 
    animation.play()

  })
  
}

export default () => { }